<info-navigation [type]="'proposals'" />
<div *ngIf="data?.length > 0; else placeholder">
  <ng-container *ngFor="let item of data; let i = index">
    <info-group [data]="item" [type]="'proposals'" [index]="i"></info-group>
  </ng-container>
</div>
<ng-template #placeholder>
  <div *ngIf="loading; else notLoading" class="placeholder">
    <p>Loading pending projects...</p>
  </div>
  <ng-template #notLoading>
    <div class="placeholder">
      <p>You currently have no pending projects.</p>
    </div>
  </ng-template>
</ng-template>
<atp-sign-accepted-dialog
  [active]="isATPSignedAccepted"
  [address]="address"
  (modalClosed)="toggleCloseAtpAcceptedModal()"
  [ngClass]="{ 'documents-dialog--active': isATPSignedAccepted }"
  [modalHeaderTitle]="atpModalHeaderTitle"
  [modalBody]="atpModalBody"
  [projectId]="projectId"
  [siteVisitRequired]="siteVisitRequired"
  [dashboard]="true"
/>
<decline-success
  [active]="isDeclineSuccessActive"
  [address]="address"
  [isFixedPrice]="isFixedPrice"
  [isAtp]="isAtp"
  (modalClosed)="toggleCloseDeclineSuccessModal()"
  [ngClass]="{ 'documents-dialog--active': isDeclineSuccessActive }"
/>
